module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_5012.a0208d32.png";